export default __webpack_public_path__ + "static/media/quotes-icon.0a8d7ede.svg";